import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbDatepickerConfig, NgbDateStruct, NgbModal, NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import {TemplateTypes} from '../../../../shared/models/template-types.enum';
import { finalize, map, mergeMap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import {TemplatesService} from '../../../../shared/services/templates.service';
import {CompilerService} from '../../../../shared/services/compiler.service';
import {MailerService} from '../../../../shared/services/mailer.service';
import {ProjectService} from '../../../../shared/services/project.service';
import {AppointmentTypes} from '../../models/appointment-types.enum';
import {ModalGenericInfoComponent} from '../../../../shared/components/modal-generic-info/modal-generic-info.component';
import {IRemoteProfile} from '../../../../shared/interfaces/iremote-profile';
import {CmsService} from '../../../../cms/services/cms.service';
import {Networks} from '../../../../shared/models/networks.enum';
import {NavigationService} from '../../../../../services/navigation.service';
import {StoreLocatorPageService} from '../../../store-locator-page/store-locator-page.service';
import {ModalSelectAgencyComponent} from '../../../../shared/components/modal-select-agency/modal-select-agency.component';
import {Agenzia} from '../../../store-locator-page/interfaces/agenzia.interface';
import { UrlSites } from 'src/app/enums/url-sites.enum';

@Component({
  selector: 'app-home-appointments',
  templateUrl: './home-appointments.component.html',
  styleUrls: ['./home-appointments.component.scss']
})
export class HomeAppointmentsComponent implements OnInit, OnDestroy {
  currentStep = 1;
  appointmentTypes = AppointmentTypes;

  selectedDate: NgbDateStruct;
  selectedTime: NgbTimeStruct;
  selectedType: string;

  name: string;
  telephone: number;
  email: string;
  note: string;

  isWTStore: boolean = false;
  isWTShop: boolean = false;
  isWtgNetworkSite: boolean = false; // sito network WTG

  appointmentSubscription: Subscription;
  message: string;
  messageClass: string;

  loadingStatus: boolean;
  loadingMessage: string;

  profile$: Observable<IRemoteProfile>;

  public brand: any;
  public selectedStore: Agenzia;
  public networks = Networks;

  public isFormOpened: boolean = false;
  public hasMultipleStores: boolean = false;

  private storeList: Agenzia[] = [];
  private storesSubscription: Subscription;
  private selectedStoreSubscription: Subscription;
  private siteUrlSubscription: Subscription;
  private brandConfigSubscribe: Subscription;

  constructor(
    private _modalService: NgbModal,
    private _templatesService: TemplatesService,
    private _compilerService: CompilerService,
    private _mailerService: MailerService,
    private _projectService: ProjectService,
    private _cmsService: CmsService,
    private dpConfig: NgbDatepickerConfig,
    private _navigationService: NavigationService,
    private _storeLocatorService: StoreLocatorPageService
  ) {
    const TODAY = new Date();
    const minDate = new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate() + 1);
    this.dpConfig.minDate = {
      day: minDate.getDate(),
      month: minDate.getMonth() + 1,
      year: minDate.getFullYear(),
    }
  }

  ngOnInit(): void {
    this._storeLocatorService.getStores();
    this.selectedStoreSubscription = this._storeLocatorService.selectedStore$.subscribe((selectedStore) => {
      this.selectedStore = selectedStore;
    });
    this.storesSubscription = this._storeLocatorService.storesList$.subscribe((storeList) => {
      if (storeList?.length) {
        // recupero tutti gli stores disponibili
        this.storeList = [...storeList];

        // booleano per verificare se è una multilocata
        this.hasMultipleStores = this.storeList?.length > 1;

        // se non è una multilocata, si seleziona automaticamente l'unico store esistente
        if (!this.hasMultipleStores) {
          this._storeLocatorService.selectedStore$.next(JSON.parse(JSON.stringify(this.storeList[0])));
        }
      }
    });

    this.loadingStatus = false;
    this.profile$ = this._projectService.getProfile();
    this.loadingMessage = 'Invio richiesta in corso...';
    if (!this.selectedTime) {
      this.selectedTime = {hour: 10, minute: 0, second: 0};
    }
    this.brandConfigSubscribe = this._cmsService.brandConfig$.subscribe(brand => {
      if (brand) this.brand = brand;
    });
    this.siteUrlSubscription = this._cmsService.siteUrl$.subscribe(siteUrl => {
      if (siteUrl) {
        if (siteUrl.includes(UrlSites.WTSTORE)) {
          this.isWTStore = true;
        }
        if (siteUrl.includes(UrlSites.WELCOMETRAVELSHOP)) {
          this.isWTShop = true;
        }
        if (siteUrl.includes(UrlSites.VACANZEWELCOMETRAVEL)) {
          this.isWtgNetworkSite = true;
        }
      }
    });
  }

  public toggleForm(event): void {
    this.resetForm();
    this.currentStep = 1;
    this.isFormOpened = !this.isFormOpened;
    if (this.isFormOpened) {
      event.srcElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  public openStoreLocatorModal(): void {
    const storeLocatorModalRef = this._modalService.open(
        ModalSelectAgencyComponent,
        {
          ariaLabelledBy: 'modal-store-locator',
          size: 'lg',
          backdrop: (this.selectedStore) ? true : 'static',
          keyboard: false
        }
    );
    storeLocatorModalRef.componentInstance.storeList = this.storeList;
    storeLocatorModalRef.componentInstance.previouslySelectedStore = this.selectedStore;
    storeLocatorModalRef.componentInstance.storeSelected.subscribe(
        (modalResult) => {
          this._storeLocatorService.selectedStore$.next(modalResult);
        }
    );
  }

  goToNextStep(): void {
    this.currentStep++;
  }

  resetForm(): void {
    this.selectedDate = undefined;
    this.selectedTime = {hour: 10, minute: 0, second: 0};
    this.selectedType = undefined;
    this.name = undefined;
    this.telephone = undefined;
    this.email = undefined;
    this.note = undefined;
  }

  openPrivacy($event: any): void {
    $event?.preventDefault();
    if (this.isWtgNetworkSite) {
      this._navigationService.getRedirectUrl('/privacy-policy').then(
          (resolved) => {
            window.open(resolved.url, '_blank');
          }
      );
    } else {
      const templateToLoad = (this.isWTStore || this.isWTShop) ? TemplateTypes.WTSHOP_STORE : TemplateTypes.GEO_PRIVACY_APPOINTMENT;
      const title = 'Informativa privacy richiesta appuntamento';

      this.openModalPrivacy(title, templateToLoad);
    }
  }

  sendRequest(): void {
    if ((!this.email || (this.email && this.email === 'nessuna')) && !this.selectedStore.email1) {
      // se mancano le email di contatto per avvisare l'agenzia dell'appuntamento, passo allo step successivo avvisando l'utente con un messaggio di errore
      this.goToNextStep();
      this.message = 'Si è verificato un errore. Non è possibile prenotare un appuntamento in questo momento. Contattaci telefonicamente.';
      this.messageClass = 'alert-danger';
      console.info('Errore invio richiesta appuntamento: email agenzia mancante');
      return;
    }
    this.loadingStatus = true;
    this.appointmentSubscription = this._templatesService.getTemplate(TemplateTypes.APPOINTMENT).pipe(
      map(e => this._compilerService.compile(e, {
        selectedDate: `${this.selectedDate.day}-${this.selectedDate.month}-${this.selectedDate.year}`,
        selectedTime: `${this.selectedTime.hour}:${this.selectedTime.minute}`,
        selectedType: this.selectedType,
        note: this.note,
        name: this.name,
        email: this.email || 'nessuna',
        telephone: this.telephone || 'nessuno'
      })),
      mergeMap(templateCompiled => this._mailerService.sendEmail({
        from: (this.email && this.email !== 'nessuna') ? this.email : this.selectedStore.email1,
        to: this.selectedStore.email1,
        body: templateCompiled,
        title: `Richiesta Appuntamento`
      })),
      finalize(() => this.loadingStatus = false)
    ).subscribe(e => {
      this.goToNextStep();
      if (e) {
        this.message = 'Richiesta inviata con successo! Verrete ricontattati al più presto per confermare data, ora e modalità.';
        this.messageClass = 'alert-success';
        this.resetForm();
      } else {
        this.message = 'Si è verificato un errore. Non è possibile prenotare un appuntamento in questo momento. Contattaci telefonicamente.';
        this.messageClass = 'alert-danger';
      }
    });
  }

  ngOnDestroy(): void {
    this._storeLocatorService.selectedStore$.next(null);

    this.storesSubscription?.unsubscribe();
    this.selectedStoreSubscription?.unsubscribe();
    this.appointmentSubscription?.unsubscribe();
    this.brandConfigSubscribe?.unsubscribe();
    this.siteUrlSubscription?.unsubscribe();
  }

  private openModalPrivacy(title: string, templateToLoad: string) {
    const modalRef = this._modalService.open(ModalGenericInfoComponent, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg'
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.template = templateToLoad;
  }
}
